/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 26.05.2016.
 */

import Grid from './grid';

export default Grid;



// WEBPACK FOOTER //
// ./src/components/EPGGrid/index.js